goog.provide("shadow.js.shim.module$date_fns$locale$eu$default");
shadow.js.shim.module$date_fns$locale$eu$default = esm_import$date_fns$locale$eu.default;
